import { omit } from 'lodash'
import {
  GET_ATTRIBUTE_VALUES_LOADING,
  GET_ATTRIBUTE_VALUES_SUCCESS,
  GET_ATTRIBUTE_VALUES_FAILURE,
  GET_ATTRIBUTE_VALUES_UNLOAD,
} from '../actions'

const defaultState = {
  loading: false,
  error: null,
  values: [],
}
const singleAttributeValues = (
  prevState = defaultState,
  { type, payload, error }
) => {
  switch (type) {
    case GET_ATTRIBUTE_VALUES_LOADING:
      return {
        ...prevState,
        loading: true,
      }
    case GET_ATTRIBUTE_VALUES_SUCCESS:
      return {
        ...prevState,
        loading: false,
        values: payload,
      }
    case GET_ATTRIBUTE_VALUES_FAILURE:
      return {
        ...prevState,
        error,
        loading: false,
      }
    default:
      return prevState
  }
}

export default (prevState = {}, action) => {
  const { type, attribute } = action

  switch (type) {
    case GET_ATTRIBUTE_VALUES_LOADING:
    case GET_ATTRIBUTE_VALUES_SUCCESS:
    case GET_ATTRIBUTE_VALUES_FAILURE:
      return {
        ...prevState,
        [attribute]: singleAttributeValues(prevState[attribute], action),
      }
    case GET_ATTRIBUTE_VALUES_UNLOAD:
      return omit(prevState, attribute)
    default:
      return prevState
  }
}



// WEBPACK FOOTER //
// ./src/reducers/attributeValues.js